/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const StockListPage = lazyLoad(
  () => import('./index'),
  module => module.StockListPage
);
